var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-found"},[_c('section',[_c('Logo'),_c('h1',[_vm._v(_vm._s(_vm.$t('main.notFound')))]),_c('router-link',{attrs:{"to":"/"}},[_c('span',[_vm._v(_vm._s(_vm.$t('main.back')))])])],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }